var _path, _path2, _path3, _g, _path4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8022_9805)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8022_9805",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8022_9805)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8022_9805)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8022_9805",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 9,
    height: 9
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2353 6H5V14.314H13.2353V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8022_9805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5048 10.8501H7.73023C7.27928 10.8506 6.84695 11.0318 6.52809 11.3537C6.20922 11.6756 6.02984 12.112 6.0293 12.5673V14.3143H12.2058V12.5673C12.2052 12.112 12.0258 11.6756 11.707 11.3537C11.3881 11.0318 10.9558 10.8506 10.5048 10.8501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11742 10.157C10.2545 10.157 11.1762 9.22642 11.1762 8.0785C11.1762 6.93058 10.2545 6 9.11742 6C7.98036 6 7.05859 6.93058 7.05859 8.0785C7.05859 9.22642 7.98036 10.157 9.11742 10.157Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8022_9805",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 8,
    width: 9,
    height: 9
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 8.68604H10.7646V17H18.9999V8.68604Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8022_9805)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9023 14.3529V14.6995H18.5798C18.5388 15.1889 18.3277 15.6479 17.9839 15.9952C17.6401 16.3425 17.1858 16.5557 16.7013 16.5972V15.9128H16.3582V16.5972C15.8737 16.5557 15.4194 16.3425 15.0756 15.9952C14.7319 15.6479 14.5208 15.1889 14.4797 14.6995H15.1572V14.3529H14.4797C14.5176 13.9014 14.7002 13.4758 14.9982 13.1399H14.113C13.6621 13.1404 13.2298 13.3217 12.9109 13.6438C12.5921 13.9659 12.4127 14.4026 12.4121 14.8582V16.6062H18.5886V14.8582C18.5884 14.6853 18.5624 14.5151 18.5128 14.3529H17.9023ZM16.7013 14.6995H17.0445V14.3529H16.7013V14.0063H16.3582V14.3529H16.0151V14.6995H16.3582V15.0462H16.7013V14.6995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.883 12.843C16.0201 12.843 16.9419 11.9125 16.9419 10.7645C16.9419 9.6166 16.0201 8.68604 14.883 8.68604C13.746 8.68604 12.8242 9.6166 12.8242 10.7645C12.8242 11.9125 13.746 12.843 14.883 12.843Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8022_9805",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8022_9805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricRoles);
export default __webpack_public_path__ + "static/media/Metric-Roles.518ce5d1ee0eebe217b78cf7ded26ff9.svg";
export { ForwardRef as ReactComponent };